import type { CampaignMessages, CampaignMessagesLocale, MessagesByLocale, Skin } from '@/libs/campaigns/types';

export const CAMPAIGN_MESSAGES_LOCALES = ['en', 'en-CA'] as const satisfies readonly CampaignMessagesLocale[];

const toMessagesLocale = (locale: string): CampaignMessagesLocale => {
  return (CAMPAIGN_MESSAGES_LOCALES as readonly string[]).includes(locale)
    ? locale as CampaignMessagesLocale
    : 'en';
};

/** Texts for a site locale, with `en` filling every key the locale doesn't override. */
export function localizeMessages<Messages>(messages: MessagesByLocale<Messages>, locale: string): Messages {
  return {
    ...messages.en,
    ...messages[toMessagesLocale(locale)],
  };
}

/** The Skin's texts for a site locale, with `en` filling every key the locale doesn't override. */
export function getCampaignMessages(skin: Skin, locale: string): CampaignMessages {
  return localizeMessages(skin.messages, locale);
}
